import * as tslib_1 from "tslib";
import { Base } from '../../components/base-component';
import './form-item-youth-page-modal.component.scss';
var FormItemYouthPageModal = /** @class */ (function (_super) {
    tslib_1.__extends(FormItemYouthPageModal, _super);
    function FormItemYouthPageModal(element) {
        return _super.call(this, element) || this;
    }
    FormItemYouthPageModal.prototype.init = function () {
        this.form = this.element.querySelector('form');
        this.submitBtn = this.element.querySelector('.js-youth-page-modal__button');
        // display views
        if (this.form) {
            this.displayLoader = this.form.querySelector(".form-container__loader");
            this.displayFields = this.form.querySelector(".form-container__fields");
            this.displaySuccess = this.form.querySelector(".form-container__success");
            this.displayError = this.form.querySelector('.form-container__error');
        }
        // checkboxes
        this.wantToBank = this.element.querySelector("input[name='want-to-bank']");
        this.wantToBorrow = this.element.querySelector("input[name='want-to-borrow']");
        this.wantToSave = this.element.querySelector("input[name='want-to-save']");
        // lists
        this.hasDegree = this.element.querySelector("select[name='has-degree']");
        this.degreeType = this.element.querySelector("select[name='degree-type']");
        // containers
        this.optionsErrorContainer = this.element.querySelector('.form__group--youth-page-modal__options-error-container');
        this.hasDegreeContainer = this.element.querySelector('.form__group--youth-page-modal__has-degree-container');
        this.degreeTypeContainter = this.element.querySelector('.form__group--youth-page-modal__degree-type-container');
        // success containers
        this.studentLoansContainer = this.element.querySelector('.form-item-youth-page-modal__success-message-container--student-loan');
        this.professionalBankingContainer = this.element.querySelector('.form-item-youth-page-modal__success-message-container--professional-banking-account');
        this.pureSaveContainer = this.element.querySelector('.form-item-youth-page-modal__success-message-container--puresave');
        this.mymoContainer = this.element.querySelector('.form-item-youth-page-modal__success-message-container--mymo');
    };
    FormItemYouthPageModal.prototype.bindEvents = function () {
        var _this = this;
        this.submitBtn.addEventListener('click', function (event) {
            var _button = event.target;
            var _form = _button.closest('form');
            var formFields = _form.querySelectorAll('input, select');
            _this.validationService.validate(formFields);
            var valid = Array.from(_form.querySelectorAll('.form__group--error'));
            if (_this.validateCheckboxSelection()) {
                if (valid.length === 0) {
                    _this.submitForm(_form);
                }
            }
        });
        if (this.wantToBank && this.hasDegree && this.degreeType) {
            this.wantToBank.addEventListener("change", function (pEvent) {
                if (_this.wantToBank.checked) {
                    _this.hasDegreeContainer.classList.remove("form__group--hidden");
                }
                else {
                    _this.hasDegreeContainer.classList.add("form__group--hidden");
                    _this.degreeTypeContainter.classList.add("form__group--hidden");
                    _this.hasDegreeContainer.classList.remove("form__group--error");
                    _this.degreeTypeContainter.classList.remove("form__group--error");
                    _this.hasDegree.value = "";
                    _this.degreeType.value = "";
                    var hasDegreeContainerErrorMsg = _this.hasDegreeContainer.querySelector(".form__group--error_message");
                    var degreeTypeContainerErrorMsg = _this.degreeTypeContainter.querySelector(".form__group--error_message");
                    if (hasDegreeContainerErrorMsg) {
                        _this.hasDegreeContainer.removeChild(hasDegreeContainerErrorMsg);
                    }
                    if (degreeTypeContainerErrorMsg) {
                        _this.degreeTypeContainter.removeChild(degreeTypeContainerErrorMsg);
                    }
                }
            });
        }
        if (this.hasDegree && this.degreeType) {
            this.hasDegree.addEventListener("change", function (pEvent) {
                if (_this.hasDegree.value === "DEGREE") {
                    _this.degreeTypeContainter.classList.remove("form__group--hidden");
                }
                else {
                    _this.degreeTypeContainter.classList.add("form__group--hidden");
                    _this.degreeTypeContainter.classList.remove("form__group--error");
                    _this.degreeType.value = "";
                    var degreeTypeContainerErrorMsg = _this.degreeTypeContainter.querySelector(".form__group--error_message");
                    if (degreeTypeContainerErrorMsg) {
                        _this.degreeTypeContainter.removeChild(degreeTypeContainerErrorMsg);
                    }
                }
            });
        }
        if (this.form) {
            var _formFields = Array.from(this.form.querySelectorAll('input, select, textarea'));
            if (_formFields) {
                _formFields.forEach(function (pEement) {
                    pEement.addEventListener('blur', function (pEvent) {
                        _this.validationService.validateBlur(pEvent.currentTarget);
                    });
                });
            }
        }
        // Reset the form
        this.form.addEventListener("custom_form_reset_event", function (pEvent) {
            _this.showDisplayView("");
            _this.resetForm();
        }, false);
    };
    // custom validation
    FormItemYouthPageModal.prototype.validateCheckboxSelection = function () {
        var _isValid = false;
        if (this.wantToBank && this.wantToBorrow && this.wantToSave) {
            if (!this.wantToBank.checked && !this.wantToBorrow.checked && !this.wantToSave.checked) {
                this.optionsErrorContainer.classList.remove('form__group--hidden');
                _isValid = false;
            }
            else {
                this.optionsErrorContainer.classList.add('form__group--hidden');
                _isValid = true;
            }
        }
        return _isValid;
    };
    FormItemYouthPageModal.prototype.submitForm = function (pForm) {
        this.showDisplayView("success");
        this.showSuccessView();
    };
    FormItemYouthPageModal.prototype.showSuccessView = function () {
        if (this.wantToBank.checked) {
            if (this.hasDegree.value === 'DEGREE' && this.degreeType.value !== '') {
                this.mymoContainer.classList.add("hidden");
                this.professionalBankingContainer.classList.remove("hidden");
            }
            else {
                this.professionalBankingContainer.classList.add("hidden");
                this.mymoContainer.classList.remove("hidden");
            }
        }
        if (this.wantToBorrow.checked) {
            this.studentLoansContainer.classList.remove("hidden");
        }
        if (this.wantToSave.checked) {
            this.pureSaveContainer.classList.remove("hidden");
        }
    };
    FormItemYouthPageModal.prototype.showDisplayView = function (pDisplay) {
        this.displayLoader.classList.add("hidden");
        this.displayFields.classList.add("hidden");
        this.displaySuccess.classList.add("hidden");
        this.displayError.classList.add("hidden");
        switch (pDisplay) {
            case "fields":
                this.displayFields.classList.remove("hidden");
                break;
            case "success":
                this.displaySuccess.classList.remove("hidden");
                break;
            case "error":
                this.displayError.classList.remove("hidden");
                break;
            case "loader":
                this.displayLoader.classList.remove("hidden");
                break;
            default:
                this.displayFields.classList.remove("hidden");
                break;
        }
    };
    FormItemYouthPageModal.prototype.resetForm = function () {
        this.studentLoansContainer.classList.add("hidden");
        this.professionalBankingContainer.classList.add("hidden");
        this.mymoContainer.classList.add("hidden");
        this.pureSaveContainer.classList.add("hidden");
        this.hasDegreeContainer.classList.add("form__group--hidden");
        this.degreeTypeContainter.classList.add("form__group--hidden");
        this.hasDegree.value = "";
        this.degreeType.value = "";
    };
    return FormItemYouthPageModal;
}(Base));
export { FormItemYouthPageModal };



//////////////////
// WEBPACK FOOTER
// ./components-wpbbsa/form-item-youth-page-modal/form-item-youth-page-modal.component.ts
// module id = 969
// module chunks = 0